import _merge from 'lodash/merge';
import _chunk from 'lodash/chunk';
import { Lightning } from '@lightningjs/sdk';
import { makeTextPatch } from '../../utils/templates';
import { PodcastInformationEntry } from '../entry/podcastInformationEntry.component';
import { colors, defaultContext, ENTRIES_GAP, getInitialStyle } from './podcastDescription.style';

export class PodcastDescription extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Description: {},
        Separator: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _attach() {
    this.onUpdate = () => {
      if (this._emittedHeight !== this.finalH) {
        this._emittedHeight = this.finalH;
        this.emit('txLoaded');
      }
    };
  }

  _detach() {
    this.onUpdate = undefined;
    this._emittedHeight = 0;
  }

  set data(value) {
    const { description } = value;
    const { colorMode, screenSize } = this._style;
    const { w } = this;
    const additionalMetadata = (value.additionalMetadata || []).filter(item => Boolean(item.details));
    const gap = ENTRIES_GAP[screenSize];
    const columnWidth = Math.round(w / 2) - gap;

    const rows = _chunk(additionalMetadata, 2).map((chunk, index) => ({
      ref: `Row${index}`,
      flex: { direction: 'row' },
      flexItem: { marginBottom: gap },
      w,
      children: chunk.map(({ title, details }) => ({
        type: PodcastInformationEntry,
        data: {
          title,
          details,
          w: columnWidth,
        },
        w: columnWidth,
        flexItem: {
          marginRight: gap,
        },
      })),
    }));

    this.patch({
      Description: makeTextPatch(description, w, colors.description[colorMode]),
      Separator: {
        w,
        visible: Boolean(additionalMetadata.length),
      },
      ...rows.reduce((result, item) => ({ ...result, [item.ref]: item }), {}),
    });
  }
}
